import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const TARGET = Date.UTC(2026, 11, 2);

const calc = () => {
  const diff = Math.max(0, TARGET - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    seconds: Math.floor((diff % 60000) / 1000),
  };
};

const FlipDigit = ({ char }) => (
  <span className="relative inline-block overflow-hidden">
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.span
        key={char}
        className="inline-block"
        initial={{ y: "-100%" }}
        animate={{ y: "0%" }}
        exit={{ y: "100%" }}
        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
      >
        {char}
      </motion.span>
    </AnimatePresence>
    <span className="absolute inset-x-0 top-1/2 h-px bg-black/40" aria-hidden="true" />
  </span>
);

const Unit = ({ value, label, testId }) => (
  <div className="flex flex-col lg:items-end" data-testid={testId}>
    <span className="flex items-baseline font-serif text-3xl sm:text-6xl lg:text-7xl leading-none tabular-nums text-[#C4A24C]">
      {String(value).padStart(2, "0").split("").map((char, i) => (
        <FlipDigit key={i} char={char} />
      ))}
    </span>
    <span className="mt-2 sm:mt-3 text-[8px] sm:text-[10px] tracking-[0.2em] sm:tracking-[0.3em] uppercase text-[#6B7280]">{label}</span>
  </div>
);

const Separator = () => (
  <span className="font-serif text-2xl sm:text-4xl lg:text-5xl text-[#C4A24C]/30 select-none" aria-hidden="true">
    ·
  </span>
);

export const Countdown = () => {
  const [t, setT] = useState(calc);

  useEffect(() => {
    const timer = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div data-testid="eu-ai-act-countdown">
      <div className="flex items-start gap-2 sm:gap-6">
        <Unit value={t.days} label="Days" testId="countdown-days" />
        <Separator />
        <Unit value={t.hours} label="Hours" testId="countdown-hours" />
        <Separator />
        <Unit value={t.minutes} label="Minutes" testId="countdown-minutes" />
        <Separator />
        <Unit value={t.seconds} label="Seconds" testId="countdown-seconds" />
      </div>
      <div className="mt-5 text-xs tracking-[0.3em] uppercase text-[#6B7280] lg:text-right">
        Until enforcement
      </div>
    </div>
  );
};
